import { createElement } from "react";
import { RouteObject } from "react-router-dom";
import { routes } from "@shared/lib/react-router";
import { SupervisionNotificationsPage } from "./ui";

export const SupervisionNotificationsPageRoute = (
  ...rest: RouteObject[]
): RouteObject => {
  return {
    path: `${routes.supervision.notifications(":projectId", ":supervisionId")}`,
    element: createElement(SupervisionNotificationsPage),
    children: [...rest],
  };
};

